import React, { useState, useMemo } from "react";
import { FaExclamationTriangle, FaTimes } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { capitalizeFirstLetter } from "../../helper";
import { TEACHER_JOURNEY_URL } from "../../constants";

const TeacherProfileProgressAlert = () => {
  const { progress: completionDataRaw } = useSelector(
    (state) => state?.auth?.user || {}
  );

  const completionData = Array.isArray(completionDataRaw)
    ? completionDataRaw
    : [];

  const [visible, setVisible] = useState(true);
  const navigate = useNavigate();

  const { totalPercentage, firstIncompleteStep } = useMemo(() => {
    let total = 0;
    let firstIncomplete = null;

    for (const step of completionData) {
      if (step.isCompleted) {
        total += parseInt(step.percentage);
      } else if (!firstIncomplete) {
        firstIncomplete = step;
      }
    }

    return { totalPercentage: total, firstIncompleteStep: firstIncomplete };
  }, [completionData]);

  const getProgressColor = (percentage) => {
    if (percentage < 50) return "bg-danger";
    if (percentage < 85) return "bg-warning";
    return "bg-success";
  };

  const handleRedirect = () => {
    const link = redirectBasedOnId(firstIncompleteStep?.id);
    navigate(link);
  };
  // console.log("completionDataRaw", completionDataRaw);

  if (!completionData.length || !firstIncompleteStep || !visible) return null;

  return (
    <div className="mt-2 mx-3">
      <div
        className="alert shadow-sm rounded-3 p-3"
        style={{
          fontSize: "0.875rem",
          backgroundColor: "#fff3cd",
          border: "1px solid #ffeeba",
        }}
        role="alert"
      >
        <div className="d-flex align-items-start justify-content-between mb-2">
          <div className="d-flex align-items-center flex-grow-1 me-3">
            <FaExclamationTriangle className="me-2 text-warning flex-shrink-0" />
            <span className="flex-grow-1">
              <strong>
                {capitalizeFirstLetter(firstIncompleteStep?.name)}
              </strong>{" "}
              is incomplete, please fill out details to complete your profile.
            </span>
            <button
              className="btn btn-sm btn_contained text-white"
              style={{ padding: "2px 10px" }}
              onClick={handleRedirect}
            >
              Complete Now
            </button>
          </div>

          <button
            type="button"
            className="btn-close flex-shrink-0 ms-2"
            aria-label="Close"
            style={{
              background: "none",
              border: "none",
              fontSize: "0.875rem",
              padding: "0.25rem",
            }}
            onClick={() => setVisible(false)}
          >
            <FaTimes />
          </button>
        </div>

        <div className="progress" style={{ height: "8px" }}>
          <div
            className={`progress-bar ${getProgressColor(totalPercentage)}`}
            role="progressbar"
            style={{ width: `${totalPercentage}%` }}
            aria-valuenow={totalPercentage}
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>

        {/*     <div className="d-flex justify-content-end">
         
        </div> */}
      </div>
    </div>
  );
};

export default TeacherProfileProgressAlert;

const redirectBasedOnId = (id) => {
  switch (id) {
    case 1:
      return `${TEACHER_JOURNEY_URL}/settings`;
    case 2:
      return `${TEACHER_JOURNEY_URL}/education`;
    case 3:
      return `${TEACHER_JOURNEY_URL}/documents`;
    case 4:
      return `${TEACHER_JOURNEY_URL}/slot`;
    case 5:
      return `${TEACHER_JOURNEY_URL}/modeOfTeaching`;
    case 6:
      return `${TEACHER_JOURNEY_URL}/courses`;
    default:
      return ``;
  }
};
